import one from '../assets/svg/projects/one.svg'
import two from '../assets/svg/projects/two.svg'
import three from '../assets/svg/projects/three.svg'
// import four from '../assets/svg/projects/four.svg'
// import five from '../assets/svg/projects/five.svg'
// import six from '../assets/svg/projects/six.svg'
// import seven from '../assets/svg/projects/seven.svg'
// import eight from '../assets/svg/projects/eight.svg'


export const projectsData = [
    {
        id: 1,
        projectName: 'Product Resell Management',
        projectDesc: 'This project aims to build an product resell management  system that consolidates all information of a resell product',
        tags: ['React', 'CSS', 'Bootstrap','Node Js','Firebase','Mongodb'],
        code: 'https://github.com/PrattayDhar/reseller-website-clint',
        demo: 'https://laptopresell-986f9.web.app/',
        image: one
    },
    {
        id: 2,
        projectName: 'Service Review Website',
        projectDesc: 'This project is a Service Review Website that allows users to obtain relevant information about the services.',
        tags: ['React', 'CSS', 'Bootstrap','Node Js','Firebase','Mongodb'],
        code: 'https://github.com/PrattayDhar/review-website-clint',
        demo: 'https://survey-helper-c11e9.web.app/',
        image: two
    },
    {
        id: 3,
        projectName: 'Learning Web Site',
        projectDesc: 'Web-based learning refers to the type of learning that uses the Internet as an instructional delivery tool to carry out various learning activities.',
        tags: ['React', 'CSS', 'Bootstrap','Node Js','Firebase','Mongodb'],
        code: 'https://github.com/PrattayDhar/course-website-clint',
        demo: 'https://course-world-33a28.web.app',
        image: three
    },
    // {
    //     id: 4,
    //     projectName: 'Android Patient Tracker',
    //     projectDesc: 'This project involves the development of an Android application for viewing and managing patient data.',
    //     tags: ['Flutter', 'Firebase'],
    //     code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     image: four
    // },
    // {
    //     id: 5,
    //     projectName: 'E-Commerce App',
    //     projectDesc: 'A Simple E-commerce application',
    //     tags: ['React Native', 'Firebase'],
    //     code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     image: five
    // },
    // {
    //     id: 6,
    //     projectName: 'Uber Lite',
    //     projectDesc: 'Uber clone',
    //     tags: ['Flutter'],
    //     code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     image: six
    // },
    // {
    //     id: 7,
    //     projectName: 'Stock Market App',
    //     projectDesc: 'A simple stock market API app',
    //     tags: ['React', 'Redux', 'Bootstrap'],
    //     code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     image: seven
    // },
    // {
    //     id: 8,
    //     projectName: 'Car Pooling System',
    //     projectDesc: 'The carpooling system merges multiple people in a car which leads to meet new people, reduces pollution',
    //     tags: ['Flutter', 'React'],
    //     code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     image: eight
    // },
]


// Do not remove any fields.
// Leave it blank instead as shown below

/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/